export enum EVENTS {
  showCustomPageModal = 'showCustomPageModal',
  scrollToElement = 'scrollToElement',
  openImage = 'openImage',
  navigate = 'navigate',
  closeModal = 'closeModal',
}

const isExpectedEvent = (event: string): event is keyof typeof EVENTS => {
  return Object.keys(EVENTS).includes(event);
};

type ICustomEvent = Event & {
  origin: string;
  data: { eventName: string; payload: any };
};

export const useEvents = (sendEmit: (event: keyof typeof EVENTS, payload: any) => void) => {
  const handleEvent = (event: ICustomEvent) => {
    if (!isExpectedEvent(event.data.eventName)) {
      return;
    }

    if (event.origin !== window.origin && !event.data.eventName) {
      return;
    }

    const messageData = event.data;

    if (event.data.eventName) {
      sendEmit(event.data.eventName, messageData);
    }
  };

  onMounted(() => window.addEventListener('message', handleEvent, false));
  onUnmounted(() => window.removeEventListener('message', handleEvent, false));
};
